import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { Box, Paper } from '@material-ui/core';
import { useIntl } from 'react-intl';
import Pagination from '../../../components/Pagination/Pagination';
import Button from '../../../components/Button/CustomButton';
import styles from '../../../assets/jss/pages/listRegisterLivestreamManagementStyle';
import CustomTable from '../../../components/Table/Table';
import FormDialog from '../../../components/Dialog/FormDialog';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import Typography from '../../../components/Typography/CustomTypography';
import { headerTableOrder, lavenderTableOrder } from '../../../assets/jss/global';
import TableProductPaymentDetail from '../../../components/TableProductPaymentDetail/TableProductPaymentDetail';
import Loader from '../../../components/Loader/Loader';
import Snackbar from '../../../components/Snackbar/Snackbar';
import { APIErrors } from '../../../common/Constants';

const useStyles = makeStyles(styles);

const ActionRow = ({ onApprove, onReject, ...rest }) => (
    <Box display="flex" alignItems="center" justifyContent="center" flexWrap="wrap" width="100%">
        <Button onClick={onApprove} style={{ fontSize: '14px' }} color="success" {...rest}>承認</Button>
        &nbsp;
        <Button onClick={onReject} style={{ fontSize: '14px' }} color="danger" {...rest}>拒否</Button>
    </Box>
);

const ListRegisterLiveStream = ({
    isLoading,
    listOrderLivestream,
    getAllOrderLivestream,
    clearAllLivestream,
    detailOrderLivestream,
    listLiveStream,
    getDetailOrderLivestream,
    listDetailOrderLivestream,
    clearDetailLivestream,
    updateStatusTransaction,
    clearUpdateStatus,
    updateStatusSuccess,
    errorsUpdateStatus,
    resentMailSuccess,
    errorsResentMail,
    resentMailOrder,
    clearResentMail,
}) => {
    const classes = useStyles();
    const intl = useIntl();
    const { shortName } = useParams();
    const [orderData, setOrderData] = useState({});
    const [orderLiveStreamList, setOrderLiveStreamList] = useState([]);
    const [openDialogDetail, setOpenDialogDetail] = useState(false);
    const [listDetailOrderLiveStream, setListDetailOrderLiveStream] = useState([]);
    const [dialog, setDialog] = useState({ isOpen: false, type: 'success', message: '' });

    useEffect(() => {
        if (shortName) {
            getAllOrderLivestream({
                eventShortName: shortName,
                page: 1,
                page_size: 20,
            });
        }

        return () => {
            clearAllLivestream();
            clearDetailLivestream();
        };
    }, [shortName, getAllOrderLivestream]);

    useEffect(() => {
        if (!_.isEmpty(listLiveStream)) {
            setOrderData(listLiveStream);
        }
    }, [listLiveStream]);

    useEffect(() => {
        if (updateStatusSuccess || resentMailSuccess) {
            getAllOrderLivestream({
                eventShortName: shortName,
                page: 1,
                page_size: 20,
            });
            clearUpdateStatus();
            clearResentMail();
        }
    }, [updateStatusSuccess, resentMailSuccess]);

    useEffect(() => {
        if (listOrderLivestream) {
            const dataTable = listOrderLivestream.map((product) => [
                product.order_no,
                product.order_date,
                product.user_email,
                product.username,
                <Button onClick={() => handleDetailOrder(product.transaction_id)} style={{ fontSize: '14px' }}>申込み内容表示</Button>,
                product.total_price ? `${intl.formatNumber(product.total_price)}円` : '無料',
                product.payment_method,
                product.payment_method === '銀行口座' ? (
                    <p style={{ textAlign: 'center' }}>
                        <p>{product.invoice_issue_date}</p>
                        {
                            (product.status === '承認済み' || product.status === '拒否済み') ? '' : <Button onClick={() => handleResentMail(product.transaction_id)} style={{ fontSize: '14px' }}>請求書再送</Button>
                        }
                    </p>
                ) : '',
                product.total_price ? product.is_paid : '',
                product.payment_method === '銀行口座' && product.status === '承認済み' ? (
                    <p>
                        <p>{product.status}</p>
                        <p>{product.approved_time}</p>
                    </p>
                ) : product.status,
                (product.status === '承認済み' || product.payment_method === 'クレジット' || product.status === '拒否済み') ? '' : (
                    <ActionRow
                        onApprove={() => handleApprovedInTable(product.transaction_id)}
                        onReject={() => handleRejectInTable(product.transaction_id)}
                        size="sm"
                    />
                ),
            ]);
            setOrderLiveStreamList(dataTable);
        }
    }, [listOrderLivestream]);

    useEffect(() => {
        if (detailOrderLivestream) {
            listDetailOrder(detailOrderLivestream);
        }
    }, [getDetailOrderLivestream, detailOrderLivestream]);

    useEffect(() => {
        if (errorsResentMail.code === APIErrors.badRequest || errorsUpdateStatus.code === APIErrors.badRequest) {
            setDialog({
                isOpen: true,
                type: 'error',
                message: !_.isEmpty(errorsResentMail)
                    ? (errorsResentMail.message.message || 'メール送信失敗') : (errorsUpdateStatus.message.message || '更新失敗'),
            });
            clearResentMail();
            clearUpdateStatus();
            getAllOrderLivestream({
                eventShortName: shortName,
                page: 1,
                page_size: 20,
            });
        }
        if (resentMailSuccess || updateStatusSuccess) {
            setDialog({
                isOpen: true,
                type: 'success',
                message: resentMailSuccess ? 'メール送信成功' : '適用しました。',
            });
        }
    }, [resentMailSuccess, errorsResentMail, resentMailOrder, updateStatusSuccess, errorsUpdateStatus, clearResentMail]);

    const handleResentMail = (id) => {
        resentMailOrder({ eventShortName: shortName, transaction_id: id });
    };

    const handleApprovedInTable = (id) => {
        updateStatusTransaction({ eventShortName: shortName, transaction_id: id, status: 1 });
    };

    const handleRejectInTable = (id) => {
        updateStatusTransaction({ eventShortName: shortName, transaction_id: id, status: 2 });
    };

    const listDetailOrder = (detailOrder) => {
        const listDetail = detailOrder.map((item) => [
            item.datetime,
            item.title,
            item.price,
        ]);
        setListDetailOrderLiveStream([listDetail]);
    };

    const handleDetailOrder = (id) => {
        getDetailOrderLivestream({ eventShortName: shortName, transaction_id: id });
        setOpenDialogDetail(true);
    };

    const handleSearchWithPage = (pageChange) => {
        getAllOrderLivestream({
            eventShortName: shortName,
            page: pageChange,
            page_size: 20,
        });
    };

    const handleCloseDialogDetail = () => {
        clearDetailLivestream();
        setOpenDialogDetail(false);
    };

    const handleCloseErrorDialog = (e, reason) => {
        if (reason === 'clickaway') return;
        setDialog({ ...dialog, isOpen: false });
    };

    return (
        <>
            <Loader isLoading={isLoading} />
            <CustomTable
                onClick={() => {}}
                tableHead={['申込みNo', '申込み日時', 'メールアドレス', '氏名', '申込み内容', '費用', '支払い方法', '請求書発送日', '支払い状況', '承認状況', 'アクション']}
                tableHeadWidth={['7%', '12%', '10%', '5%', '10%', '8%', '8%', '12%', '8%', '10%', '10%']}
                tableData={orderLiveStreamList}
                tableFooter={(
                    <Box display="flex" justifyContent="center">
                        <Pagination
                            page={orderData.page}
                            total={orderData.total_page}
                            onChange={(page) => handleSearchWithPage(page)}
                        />
                    </Box>
                )}
                pointerLess
            />
            <FormDialog
                title="申込み内容"
                titleAlign="center"
                isOpen={openDialogDetail}
                visibleCustomizeCloseBtn
                handleClose={handleCloseDialogDetail}
            >
                <GridContainer style={{ paddingTop: '6px', paddingBottom: '6px' }}>
                    <GridItem>
                        <Paper elevation={3} classes={{ root: classes.room }}>
                            <GridItem xs={12} md={12} className={classes.titleDetail}>
                                <Typography variant="h6">
                                    内訳
                                </Typography>
                            </GridItem>
                            <GridItem xs={12} md={12}>
                                <TableProductPaymentDetail
                                    cellColor={headerTableOrder}
                                    colorRowTitle={lavenderTableOrder}
                                    onClick={() => {}}
                                    tableHead={['開催日時', 'タイトル', '単価(税込)']}
                                    tableHeadWidth={['60%', '25%', '15%']}
                                    tableData={listDetailOrderLiveStream}
                                    hover={false}
                                    pointerLess
                                    className={classes.customTable}
                                    lengthCol={3}
                                />
                            </GridItem>
                        </Paper>
                    </GridItem>
                    {listDetailOrderLivestream.payment_method === '銀行口座' && (
                        <GridItem xs={12} md={12} className={classes.titleDetail}>
                            <Typography variant="h6" className={classes.invoiceNumber}>
                                {`請求書番号: ${listDetailOrderLivestream.invoice_number}`}
                            </Typography>
                        </GridItem>
                    )}
                    <GridItem xs={12} md={12} style={{ padding: '15px 0' }}>
                        <Typography variant="h6" className={classes.totalPrice}>
                            {`合計金額（税込）: ${listDetailOrderLivestream.total_price}`}
                        </Typography>
                    </GridItem>
                </GridContainer>
            </FormDialog>
            <Snackbar
                open={dialog.isOpen}
                onClose={handleCloseErrorDialog}
                message={dialog.message}
                severity={dialog.type}
            />
        </>
    );
};

ActionRow.propTypes = {
    onApprove: PropTypes.func.isRequired,
    onReject: PropTypes.func.isRequired,
};

ListRegisterLiveStream.defaultProps = {
    isLoading: false,
    listOrderLivestream: [],
    detailOrderLivestream: [],
    listLiveStream: {},
    listDetailOrderLivestream: {},
    getAllOrderLivestream: () => {},
    clearAllLivestream: () => {},
    getDetailOrderLivestream: () => {},
    clearDetailLivestream: () => {},
    updateStatusTransaction: () => {},
    clearUpdateStatus: () => {},
    updateStatusSuccess: false,
    errorsUpdateStatus: {},
    resentMailSuccess: false,
    errorsResentMail: {},
    resentMailOrder: () => {},
    clearResentMail: () => {},
};

ListRegisterLiveStream.propTypes = {
    isLoading: PropTypes.bool,
    listOrderLivestream: PropTypes.oneOfType([() => null, PropTypes.array]),
    detailOrderLivestream: PropTypes.oneOfType([() => null, PropTypes.array]),
    listLiveStream: PropTypes.oneOfType([() => null, PropTypes.object]),
    listDetailOrderLivestream: PropTypes.oneOfType([() => null, PropTypes.object]),
    clearDetailLivestream: PropTypes.func,
    getAllOrderLivestream: PropTypes.func,
    clearAllLivestream: PropTypes.func,
    getDetailOrderLivestream: PropTypes.func,
    updateStatusTransaction: PropTypes.func,
    clearUpdateStatus: PropTypes.func,
    updateStatusSuccess: PropTypes.bool,
    errorsUpdateStatus: PropTypes.oneOfType([() => null, PropTypes.object]),
    resentMailSuccess: PropTypes.bool,
    errorsResentMail: PropTypes.oneOfType([() => null, PropTypes.objectOf]),
    resentMailOrder: PropTypes.func,
    clearResentMail: PropTypes.func,
};

export default ListRegisterLiveStream;
